import { createFileRoute } from '@tanstack/react-router'
import { Livechat } from '@/components/settings-route/multi-channel/livechat/index.jsx'

export const Route = createFileRoute('/_auth/settings/multi-channels/livechat')(
  {
    component: Livechat,
  },
)
